import { downloadCSV } from "../utils/csvDownload";

interface AggregatedQuarterGlobalAdminProps {
    emissionsData: any[];
    nonDetectsData: any[];
    belowThresholdData: any[];
    isLoading: boolean;
}

export const AggregatedQuarterGlobalAdmin = ({
    emissionsData,
    nonDetectsData,
    belowThresholdData,
    isLoading,
}: AggregatedQuarterGlobalAdminProps) => {
    // Flatten nested quarter+provider data for CSV export
    const flattenedEmissions =
        emissionsData?.flatMap((quarter) =>
            quarter.data.map((provider: any) => ({
                quarter: quarter.quarter,
                startDate: quarter.startDate,
                endDate: quarter.endDate,
                dataProvider: provider.dataProvider,
                dataProviderName: provider.dataProviderName,
                secondaryDataSource: provider.secondaryDataSource,
                totalEmissions: provider.totalEmissions,
                count: provider.count,
            })),
        ) || [];

    const flattenedNonDetects =
        nonDetectsData?.flatMap((quarter) =>
            quarter.data.map((provider: any) => ({
                quarter: quarter.quarter,
                startDate: quarter.startDate,
                endDate: quarter.endDate,
                dataProvider: provider.dataProvider,
                dataProviderName: provider.dataProviderName,
                secondaryDataSource: provider.secondaryDataSource,
                count: provider.count,
            })),
        ) || [];

    const flattenedBelowThreshold =
        belowThresholdData?.flatMap((quarter) =>
            quarter.data.map((provider: any) => ({
                quarter: quarter.quarter,
                startDate: quarter.startDate,
                endDate: quarter.endDate,
                dataProvider: provider.dataProvider,
                dataProviderName: provider.dataProviderName,
                secondaryDataSource: provider.secondaryDataSource,
                totalEmissions: provider.totalEmissions,
                count: provider.count,
            })),
        ) || [];

    return (
        <div className="h-full flex flex-col items-center justify-center p-8 space-y-4">
            <button
                onClick={() =>
                    downloadCSV(flattenedEmissions, "emissions_per_quarter.csv")
                }
                disabled={isLoading || !flattenedEmissions.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed w-80"
            >
                {isLoading ? "Loading..." : "Download Emissions Data (CSV)"}
            </button>
            <button
                onClick={() =>
                    downloadCSV(
                        flattenedNonDetects,
                        "nondetects_per_quarter.csv",
                    )
                }
                disabled={isLoading || !flattenedNonDetects.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed w-80"
            >
                {isLoading ? "Loading..." : "Download Non-Detects Data (CSV)"}
            </button>
            <button
                onClick={() =>
                    downloadCSV(
                        flattenedBelowThreshold,
                        "below_threshold_per_quarter.csv",
                    )
                }
                disabled={isLoading || !flattenedBelowThreshold.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed w-80"
            >
                {isLoading
                    ? "Loading..."
                    : "Download Below Threshold Data (CSV)"}
            </button>
        </div>
    );
};
